import { videoConfig } from '@/config/video';
import { getDateParseFormat, getNow } from '@/utilities/dateUtils';
import { DateTime } from 'luxon';

export interface LottoCountdownType {
  live: DateTime;
  start: DateTime;
  end: DateTime;
}

export function getCurrentLottoCountdown(): LottoCountdownType | null {
  const now = getNow();
  const today = now.setLocale('de-DE').toFormat(getDateParseFormat('Dayname'));
  const liveTime = videoConfig.liveTimes.find((t) => t.day === today) || null;

  if (liveTime === null) {
    return null;
  }

  const { time } = liveTime;
  // always has to be today because of liveTime, so just use "now"!
  // const next = parse(`${day} ${time}`, getDateParseFormat('DayAndTime'));
  // now.toISODate() ???
  const next = DateTime.fromSQL(
    `${now.year}-${now.month.toString().padStart(2, '0')}-${now.day
      .toString()
      .padStart(2, '0')} ${time}:00.000 Europe/Berlin`
  );
  const live = next;
  const start = DateTime.fromMillis(
    live.toMillis() - videoConfig.liveMinutesPrior * 60 * 1000,
    { zone: 'Europe/Berlin' }
  );
  const end = DateTime.fromMillis(
    live.toMillis() + videoConfig.liveMinutesAfter * 60 * 1000,
    { zone: 'Europe/Berlin' }
  );
  return now.toMillis() <= end.toMillis() && now.toMillis() >= start.toMillis()
    ? { live, start, end }
    : null;
}
